var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Timeline',{attrs:{"title":_vm.$t('nav.dms'),"timeline":_vm.timeline,"timeline-name":'dms'}})}
var staticRenderFns = []
export { render, staticRenderFns }